module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cid-head"
  }, [_c('div', {
    staticClass: "cid-head-head"
  }, [_c('div', {
    staticClass: "cid-head-head-left"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "placeholder": _vm.inputPlaceholder
    },
    on: {
      "click": function($event) {
        _vm.goToSearch()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cid-head-foot"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    attrs: {
      "id": "0"
    },
    on: {
      "click": function($event) {
        _vm.handleOne(0, '')
      }
    }
  }, [_c('a', {
    class: _vm.classArray[0]
  }, [_vm._v("全部")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "1"
    },
    on: {
      "click": function($event) {
        _vm.handleOne(1, 't=1')
      }
    }
  }, [_c('a', {
    class: _vm.classArray[1]
  }, [_vm._v("女装")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "9"
    },
    on: {
      "click": function($event) {
        _vm.handleOne(9, 't=9')
      }
    }
  }, [_c('a', {
    class: _vm.classArray[9]
  }, [_vm._v("男装")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "10"
    },
    on: {
      "click": function($event) {
        _vm.handleOne(10, 't=10')
      }
    }
  }, [_c('a', {
    class: _vm.classArray[10]
  }, [_vm._v("内衣")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "2"
    },
    on: {
      "click": function($event) {
        _vm.handleOne(2, 't=2')
      }
    }
  }, [_c('a', {
    class: _vm.classArray[2]
  }, [_vm._v("母婴")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "3"
    },
    on: {
      "click": function($event) {
        _vm.handleOne(3, 't=3')
      }
    }
  }, [_c('a', {
    class: _vm.classArray[3]
  }, [_vm._v("化妆")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "4"
    },
    on: {
      "click": function($event) {
        _vm.handleOne(4, 't=4')
      }
    }
  }, [_c('a', {
    class: _vm.classArray[4]
  }, [_vm._v("居家")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "5"
    },
    on: {
      "click": function($event) {
        _vm.handleOne(5, 't=5')
      }
    }
  }, [_c('a', {
    class: _vm.classArray[5]
  }, [_vm._v("鞋包")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "6"
    },
    on: {
      "click": function($event) {
        _vm.handleOne(6, 't=6')
      }
    }
  }, [_c('a', {
    class: _vm.classArray[6]
  }, [_vm._v("美食")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "7"
    },
    on: {
      "click": function($event) {
        _vm.handleOne(7, 't=7')
      }
    }
  }, [_c('a', {
    class: _vm.classArray[7]
  }, [_vm._v("文体")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "8"
    },
    on: {
      "click": function($event) {
        _vm.handleOne(8, 't=8')
      }
    }
  }, [_c('a', {
    class: _vm.classArray[8]
  }, [_vm._v("数码")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cid"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d3a4134","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taoke/CidHeader.vue
// module id = 207
// module chunks = 2